import SharedList from './SharedList';

export default SharedList;
